import { createAPI } from '@common'

export default {
  // 任务队列--详情
  getMamAITaskDetail: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0bj0ubtl0efubjm', 'get', config),
  // 任务队列-删除
  deleteMamAITask: (config) => createAPI('customEncryptApiName-1/0w20nbn0bj0ubtl', 'delete', config)
}
